import _ from "lodash";
import {BLOG_POST_STATUS_LIST, TONES_LIST} from "../../content/constants/blog.constant";
import {PROMPT_TYPE_LIST} from "../../content/constants/prompt.constant";

export const PRODUCT_BLOG_POST_TAB_LIST = [
    {key: 'blog-post-content', label: 'Blog Post Content'},
    {key: 'featured-image', label: 'Featured Image'},
    {key: 'shopify-blog-article', label: 'Shopify Blog Article'},
    /*{key: 'product-list', label: 'Product List'},*/
];

// export const DEFAULT_PRODUCT_BLOG_POST_TAB = {key: 'product-list', label: 'Product List'};
export const DEFAULT_PRODUCT_BLOG_POST_TAB = {key: 'blog-post-content', label: 'Blog Post Content'};
export const BLOG_POST_FEATURED_IMAGE_SIZE = {width: 1800, height: 1000};

export const PRODUCT_BLOG_POST_INPUT_FIELDS = [
    {attribute: "title", label: "Title", type: 'text', readOnly: false, group: 'blog'},
    {
        attribute: "toneOfVoice",
        label: "Tone Of Voice",
        type: 'select',
        readOnly: false,
        group: 'blog',
        options: TONES_LIST,
        default: 'Conversational',
        cssClass: 'w-1/3'
    },
    {
        attribute: "status",
        label: "Status",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: BLOG_POST_STATUS_LIST,
        default: 'New'
    },
];

export const COLLECTION_INPUT_FIELDS = [
    {
        attribute: "toneOfVoice",
        label: "Tone Of Voice",
        type: 'select',
        readOnly: false,
        group: 'meta',
        options: TONES_LIST,
        default: 'Conversational',
        cssClass: 'w-full'
    }
];

export const BLOG_INPUT_FIELDS = [
    {
        attribute: "type",
        label: "Type",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: PROMPT_TYPE_LIST,
        default: 'Blog'
    }
];
